import { v4 as uuidv4 } from 'uuid';

export default {
	namespaced: true,
	state: {
    tooltip: null
	},
	getters: {
    getTooltip: state => state.tooltip
	},
	mutations: {
    SET_TOOLTIP: (state, value) => state.tooltip = value
	},
	actions: {
    setTooltip: ({commit}, value) => commit('SET_TOOLTIP', {
        ... value,
        id: uuidv4(),
    }),
    clearTooltip: ({commit}) => commit('SET_TOOLTIP', null)
	}
}
